// extracted by mini-css-extract-plugin
export default {"page":"styles_page__Az20w","content":"styles_content__3nh9A","main":"styles_main__RUR9a"};